import { QueryKey } from '@tanstack/react-query';
import type { ShipmentListDTO } from '@uturn/api/v1';
import { useParentLocation } from '@uturn/portal/router/hooks/shipments-location';
import { useShipmentsSearchStore } from '@uturn/portal/store/shipments/shipments-search';
import { PaginationCompact } from '@uturn/ui-kit';
import { ShipmentCard } from './shipment-card';
import { ShipmentPageProps } from './shipment-page';

type ShipmentsListProps = {
	shipments: ShipmentListDTO[];
	page: number;
	setPage: (page: number) => void;
	parentQueryKey: QueryKey;
	details: ShipmentPageProps['details'];
	hasQuotes?: boolean;
};

export const ShipmentsList = ({
	shipments,
	page,
	setPage,
	parentQueryKey,
	details,
	hasQuotes,
}: ShipmentsListProps) => {
	const { totalPages } = useShipmentsSearchStore();
	const parentLocation = useParentLocation();

	return (
		<>
			{shipments.map((shipment: ShipmentListDTO) => (
				<ShipmentCard
					key={shipment.shipmentNumber}
					shipmentNumber={shipment.shipmentNumber}
					shipmentId={shipment.shipmentNumber}
					shipmentStatus={shipment.status}
					shipmentReference={shipment.shipperReference ?? undefined}
					details={details(shipment)}
					hasPendingChange={shipment.pendingChangeRequest ?? false}
					quoteCount={hasQuotes ? (shipment.quoteCount ?? 0) : undefined}
					routes={
						shipment.locationActions?.sort(
							(a, b) => a.sequenceNumber - b.sequenceNumber,
						) ?? []
					}
					parentQueryKey={parentQueryKey}
					parentLocation={parentLocation}
					targetPrice={shipment.price}
					feeValue={shipment.shipmentFee}
					totalPrice={shipment.priceIncludingShipmentFee}
				/>
			))}
			<PaginationCompact
				page={page}
				setPage={setPage}
				totalPages={totalPages}
			/>
		</>
	);
};
